import type { ReactNode } from "react";
import type { Door } from "../_content/card";
import { Icon } from "../_family/Icon";
import { LANGS } from "./lang";

/** A code window's bar in a door: its icon and its name. */
export function Bar({ door }: { door: Door }) {
  const lang = LANGS.find((l) => l.door === door)!;
  return (
    <div className="bar lb">
      <Icon name={lang.icon} />
      {lang.label}
    </div>
  );
}

/** A code window: the copy button and the frame's code. */
export function Win({ children }: { children: ReactNode }) {
  return <div className="win">{children}</div>;
}
